import { OrderedMap, Map } from 'immutable';

import WorkspaceMeetingModeConstants from 'Shared/constants/WorkspaceMeetingMode.constants';

class WorkspaceMeetingModeHelper {
  static getTypingParticipants(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return OrderedMap();
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.TYPING_PARTICIPANTS);
  }

  static getNumsteps(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.NUMSTEPS);
  }

  static getCreatedAt(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.CREATED_AT);
  }

  static getSeenWorkspaceItemIds(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.SEEN_WORKSPACE_ITEM_IDS);
  }

  static getSeenWorkspaceItemIdsInNavigationalOrder(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.SEEN_WORKSPACE_ITEM_IDS_IN_NAVIGATIONAL_ORDER);
  }

  static getStepIndex(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.STEP_INDEX);
  }

  static getState(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.STATE);
  }

  static getParticipantIds(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.PARTICIPANT_IDS);
  }

  static getWorkspaceMeetingItemId(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.WORKSPACE_ITEM_ID);
  }

  static getWorkspaceMeetingItemUuid(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.WORKSPACE_ITEM_UUID);
  }

  static getWorkspaceSlug(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }
    return meetingMode.get(WorkspaceMeetingModeConstants.Model.WORKSPACE_SLUG);
  }

  static getId(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }

    return meetingMode.get(WorkspaceMeetingModeConstants.Model.ID);
  }

  static getActive(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }

    return meetingMode.get(WorkspaceMeetingModeConstants.Model.ACTIVE);
  }

  static getIsLastAgendaItem(meetingMode) {
    if (!Map.isMap(meetingMode)) {
      return false;
    }

    return meetingMode.get(WorkspaceMeetingModeConstants.Model.IS_LAST_AGENDA_ITEM);
  }
}

export default WorkspaceMeetingModeHelper;
